import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filexlsFilled"
const FilexlsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.856 15.12Q18.341 15.121 18.746 15.203 18.88 15.23 19.006 15.266 19.258 15.337 19.471 15.442 19.685 15.546 19.861 15.68 19.903 15.714 19.944 15.75T20.025 15.822Q20.104 15.897 20.172 15.979 20.274 16.099 20.352 16.236 20.406 16.327 20.449 16.426 20.49 16.521 20.523 16.625L20.552 16.73Q20.573 16.815 20.588 16.903 20.61 17.036 20.618 17.177L20.623 17.277H18.999L18.995 17.224Q18.987 17.163 18.969 17.104C18.865 16.75 18.497 16.524 17.986 16.494Q17.93 16.493 17.871 16.492 17.63 16.492 17.443 16.543 17.3 16.583 17.193 16.643C17.052 16.726 16.954 16.838 16.904 16.968Q16.867 17.066 16.867 17.177V17.182C16.866 17.553 17.19 17.748 17.928 17.887L18.633 18.02C20.089 18.3 20.766 18.89 20.766 19.99V19.996C20.766 21.366 19.69 22.238 17.87 22.238 16.162 22.238 15.081 21.48 15.005 20.166L15 20.082H16.624L16.634 20.134C16.718 20.576 17.232 20.867 17.903 20.867 18.6 20.867 19.028 20.57 19.028 20.143V20.138C19.028 19.748 18.723 19.567 17.918 19.41L17.215 19.277C16.098 19.07 15.414 18.58 15.204 17.83Q15.195 17.8 15.188 17.766 15.176 17.718 15.165 17.67 15.157 17.616 15.152 17.56 15.134 17.436 15.133 17.3V17.297C15.133 15.973 16.281 15.12 17.856 15.12M5.18 15.244 6.44 17.572H6.495L7.745 15.244H9.683L7.498 18.653V18.677L9.664 22.114H7.703L6.365 19.886H6.322L4.994 22.114H3.137L5.237 18.662V18.634L3.142 15.244z" />
          <path d="M12.242 20.71H15.084V22.113H10.494V15.244H12.243z" />
          <path d="M14.25 5.989C14.25 7.232 15.257 8.239 16.5 8.239H21V14.681Q20.892 14.582 20.773 14.491C19.967 13.871 18.936 13.62 17.856 13.62 16.812 13.62 15.783 13.9 14.98 14.53 14.37 15.006 13.934 15.656 13.743 16.416V13.744H6.849L6.46 14.464 6.073 13.743H3V2.989C3 2.161 3.672 1.489 4.5 1.489H14.25z" />
          <path d="M19.616 6.739H16.5C16.086 6.739 15.75 6.403 15.75 5.989V2.551z" />
        </svg>
      }
    </span>
  )
}
export default FilexlsFilledIcon
